export default __webpack_public_path__ + "static/media/il_404.02c40e7c.svg";